//
import AssetDiscountTypeModel from '@/models/HumanResource/HrAssetDiscountType'

//
export default [
    {
        name    : 'hr_asset_discount_type_id',
        flex    : {
            xs12: true,
        },
        props   : {
            hideDetails : true,
            itemText    : 'type',
            itemValue   : 'id',
            label       : 'Tipo de descuento',
            model       : AssetDiscountTypeModel,
            noObject    : true,
            paramSearch : 'type',
        },
        type    : 'autocomplete',
        value   : [],
    },
]